import { render, staticRenderFns } from "./SkuList.vue?vue&type=template&id=00c38ce9&scoped=true"
import script from "./SkuList.vue?vue&type=script&lang=js"
export * from "./SkuList.vue?vue&type=script&lang=js"
import style0 from "./SkuList.vue?vue&type=style&index=0&id=00c38ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c38ce9",
  null
  
)

export default component.exports